export const MemberTrainEvaluationEn = {
    xunjiadang:'Training list evaluation',
    wodepingjia:'My evaluation',
    daipingjia:'Order to be evaluated',
    zuanjiaxinxi:'Expert information',
    pingjianeirong:'Evaluation content',
    pingjiazuantai:'Evaluation state',
    dingdangneirong:'Order content',
    jiage:'Price',
    zhuantai:'status',
    caozuo:'operation'
}


// WEBPACK FOOTER //
// ./src/lang/member/MemberTrainEvaluation/MemberTrainEvaluationEn.js